export const AUTH_FOOTER_CONTACT_US_LABEL = 'Contact Us';
export const AUTH_FOOTER_MANAGE_COOKIE_PREFERENCES_LABEL = 'Manage Cookie Preferences';
